import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import Accident from "./Accident";
import {
	accidentDescription,
	accidentSummary,
	accidentContributingFactors,
	findGuilty
} from "../util/Helpers";
import Portal from "../Portal";
import DownloadModal from "./DownloadModal";
import CarBrainModal from "./CarBrainModal";
import AppContext from "../context";
import CarLeadModal from "./CarLeadModal";
import Pdf from "./Pdf";
import AccidentMobile from "./AccidentMobile";
import RecallModal from "./RecallModal";
// const duiStrings = ["HAD BEEN DRINKING", "UNDER DRUG INFLUENCE"];
const duiStrings = ["never trigger dui"];
import { useTranslation } from "react-i18next";

export default function Detailed() {
	const params = useParams();
	const location = useLocation();
	const [a, setA] = useState(
		location.state?.preview ? location.state.preview : null
	);
	const [ajax, setAjax] = useState(location.state?.preview ? false : true);
	const accident = useRef({});
	const id = params.id;
	const { modal } = useContext(AppContext);
	let mode = "accident";
	if (location.pathname.indexOf("pdf") > -1) mode = "pdf";
	if (location.pathname.indexOf("business") > -1) mode = "business-pdf";

	const [userData, setUserData] = useState({});
	const [error, setError] = useState("");
	const { t } = useTranslation();

	useEffect(() => {
		if (modal) {
			/* istanbul ignore next */
			document.getElementsByTagName("body")[0].classList.add("has-modal");
		} else {
			document.getElementsByTagName("body")[0].classList.remove("has-modal");
		}
	}, [modal]);

	const findBadge = (name) => {
		if (name) {
			axios
				.get(`agency?name=${name}`)
				.then((dd) => {
					// console.log(dd.data);
					if (dd.data.length) {
						accident.current.badge_url = dd.data[0].badge_url;
						accident.current.agency_phone = dd.data[0].phone;
						accident.current.non_emergency_number =
							dd.data[0].non_emergency_number;
					} else {
						accident.current.agency_phone = "";
						accident.current.non_emergency_number = "";
						accident.current.badge_url =
							"https://myaccident.org/images/badges-" +
							accident.current.state.toLowerCase() +
							"/" +
							name
								.toLowerCase()
								.replace(/,/g, "")
								.replace(/pd/g, "police department")
								.replace(" co so", " county sheriff's office")
								.replace(
									/county sheriff's office.*/g,
									"county sheriff's office"
								)
								.replace(/ /g, "-")
								.replace(
									"los-angeles-county-sheriff's-office",
									"los-angeles-county-sheriff's-department"
								)
								.replace(
									"kern-county-sheriff's-office",
									"kern-county-sheriff's-department"
								) /* this replace is a hotfix until we finalize a naming convention for all our CA agencies */ +
							".jpg";
					}
					setA({ ...accident.current });
					setAjax(false);
				})
				.catch((e) => {
					setAjax(false);
				});
		} else {
			setA({ ...accident.current });
			setAjax(false);
		}
	};

	const sortPassengers = (a) => {
		a.hasDUI = false;
		a.people_count = 0;
		a.vehicles.forEach((v) => {
			const newP = [];
			v.participants.forEach((p) => {
				a.people_count++;
				if (p) {
					if (p.type === "DRIVER") newP.unshift(p);
					else newP.push(p);
					if (
						duiStrings.includes(p.alcohol) ||
						duiStrings.includes(p.specimen) ||
						(p.alcohol && p.alcohol.indexOf("POSITIVE") > -1)
					)
						a.hasDUI = true;
				}
			});
			v.participants = newP;
		});
	};

	useEffect(() => {
		if (mode === "pdf") {
			if (isNaN(id)) {
				// console.log("LOAD LEAD");
				axios
					.get(`leads/get-lead/${id}`)
					.then((d) => {
						// console.log(d.data);
						if (d.data.success) {
							setUserData({
								website: "https://app.myaccident.org",
								footer: "Provided By - MyAccident.org",
								logo: "https://app.myaccident.org/assets/logo.png",
								createdFor: d.data.lead.firstName
									? d.data.lead.firstName + " " + d.data.lead.lastName
									: undefined
							});
							loadAccident(d.data.lead.accidentId);
						} else {
							setAjax(false);
							setError("Unknown error happened. Please contact our support.");
						}
					})
					.catch(() => {
						axios
							.get(`leads/get-deleted-lead/${id}`)
							.then((dd) => {
								if (dd.data.success) {
									setUserData({
										website: "https://app.myaccident.org",
										footer: "Provided By - MyAccident.org",
										logo: "https://app.myaccident.org/assets/logo.png",
										createdFor: dd.data.lead.firstName
											? dd.data.lead.firstName + " " + dd.data.lead.lastName
											: undefined
									});
									loadAccident(dd.data.lead.accidentId);
								} else {
									setAjax(false);
									setError(
										"Unknown error happened. Please contact our support."
									);
								}
							})
							.catch(() => {
								setError("Your report is not found or expired.");
							});
					});
			} else {
				setUserData({
					website: "https://app.myaccident.org",
					footer: "Provided By - MyAccident.org",
					logo: "https://app.myaccident.org/assets/logo.png"
				});
				loadAccident(id);
			}
		} else if (mode === "business-pdf") {
			axios
				.get(`businessAccount/pdf-get-info/${params.id}/${params.userId}`)
				.then((d) => {
					if (d.data.success && d.data.accident) {
						setUserData(d.data.userData);
						loadAccident(d.data.accident.custom_id);
					}
				});
		} else {
			loadAccident(id);
		}
	}, []);

	const findRecall = () => {
		const vins = [];
		if (accident.current.vehicles) {
			accident.current.vehicles.forEach((v) => {
				vins.push(v.vin_code || "");
				// v.recallData = ["abc"];
			});

			axios
				.get(`search/recall?vin=${vins.join(";")}`)
				.then((d) => {
					if (d.data.success) {
						accident.current.vehicles.forEach((v) => {
							if (d.data.data[v.vin_code])
								v.recallData = d.data.data[v.vin_code];
							// v.recallData = ["abc"];
						});

						setA({ ...accident.current });
						// console.log(accident.current);
					}
				})
				.catch((e) => console.log(e));
		}
	};

	const loadAccident = (accidentId) => {
		axios
			.get(`accident/${accidentId}/detailed`)
			.then((d) => {
				if (d.data.success) {
					// console.log(accident.current);
					accident.current = d.data.accident;
					accident.current.at_fault = findGuilty(accident.current);
					accident.current.description = accidentDescription(accident.current);
					accident.current.summary = accidentSummary(accident.current);
					sortPassengers(accident.current);
					accident.current.accident_contributing_factors = accident.current
						.vehicles
						? accident.current.vehicles.map((vehicle, index) =>
								vehicle.contributing_factor1
									? accidentContributingFactors(vehicle, index + 1)
									: null
						  )
						: null;
					setA(accident.current);
					findBadge(accident.current.agency);
					findRecall();
					document
						.getElementsByTagName("body")[0]
						.classList.add(d.data.accident.state);
				} else {
					setError("Unknown error happened. Please contact our support.");
				}
			})
			.catch((e) => {
				setAjax(false);
				setError("Accident not found.");
				// console.log(e);
			});
	};

	if (error)
		return (
			<div
				style={{
					margin: 20,
					textAlign: "center",
					color: "var(--red)",
					fontWeight: "bold"
				}}
			>
				{error}
			</div>
		);
	if (ajax)
		return (
			<div style={{ margin: 20, textAlign: "center" }}>
				<img src="/assets/ajax-loader.gif" alt="loading" />
				&nbsp;Loading...
			</div>
		);
	if (a !== null)
		return (
			<>
				{mode === "pdf" || mode === "business-pdf" ? (
					<Pdf a={a} userData={userData} id={id} />
				) : (
					<>
						{window.innerWidth < 800 ? (
							<AccidentMobile a={a} />
						) : (
							<Accident a={a} />
						)}
					</>
				)}
				{modal ? (
					<Portal>
						{modal === "download" && <DownloadModal a={a} />}
						{modal.startsWith("carBrain") && (
							<CarBrainModal a={a} k={modal.split("-")[1]} />
						)}
						{modal.startsWith("carLead") && (
							<CarLeadModal a={a} k={modal.split("-")[1]} />
						)}
						{modal.startsWith("recall") && (
							<RecallModal a={a} k={modal.split("-")[1]} />
						)}
					</Portal>
				) : null}
			</>
		);
	return null;
}
